import moment from 'moment-business-days';

const dayAdjustments = {
  Monday: -5,
  Tuesday: -5,
  Wednesday: 0,
  Thursday: 5,
  Friday: 5,
  Saturday: 0,
  Sunday: 0,
};

export function getDayAdjustment(dateStr) {
  const day = moment(dateStr, 'MM/DD/YYYY').format('dddd');
  return dayAdjustments[day] ?? 0;
}

export function getDayAdjustmentByName(dayName) {
  return dayAdjustments[dayName] ?? 0;
}

export function applyDayAdjustment(cost, dateStr) {
  return Math.max(0, cost + getDayAdjustment(dateStr));
}

export function applyDayAdjustmentByName(cost, dayName) {
  return Math.max(0, cost + getDayAdjustmentByName(dayName));
}
